module.exports = __webpack_public_path__ + "static/media/drivers.e22e0593.svg";